<template>
    <div class="com-codics-hbb-order-admin-goods-order-body">
        <div class="com-codics-hbb-order-admin-goods-order-bar-content">
            <el-select v-model="nowType" style="float:left;margin-right:15px;" placeholder="请选择订单类型"
                @change="listOrdersFuc">
                <el-option v-for="(item, index) in typeOptions" :key="index" :label="item.label" :value="item.value">
                </el-option>
            </el-select>
            <el-date-picker class="com-codics-hbb-order-admin-goods-order-bar-input"
                style="margin-right: 15px;width: 350px !important;" v-model="timeData" type="datetimerange"
                align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                :picker-options="pickerOptions" @change="listOrdersFuc" value-format="timestamp">
            </el-date-picker>
            <el-select style="float:left;margin-right:15px;" v-model="nowCid" clearable filterable remote
                reserve-keyword placeholder="请选择销售" :remote-method="queryUsersFuc" :loading="loading"
                @change="listOrdersFuc">
                <el-option v-for="(item, index) in userData" :key="index" :label="item.nickname + '-' + item.account"
                    :value="item.id">
                </el-option>
            </el-select>
            <el-select style="float:left;margin-right:15px;" v-model="nowSid" clearable filterable remote
                reserve-keyword placeholder="请选择客户" :remote-method="queryCustomFuc" :loading="loading"
                @change="listOrdersFuc">
                <el-option v-for="(item, index) in customData" :key="index" :label="item.name + '-' + item.com"
                    :value="item.id">
                </el-option>
            </el-select>
            <el-input class="com-codics-hbb-order-admin-goods-order-bar-input" v-model="searchTxt"
                placeholder="请输入订单信息..." clearable @input="searchChange" @change="listOrdersFuc">
            </el-input>
            <MyButton style="float: right;" @click.native="jumpToPage('产品商城', {}, {})">&#xe6be; 产品商城</MyButton>
            <el-popconfirm confirm-button-text='好的' cancel-button-text='不用了' icon="el-icon-info" icon-color="red"
                title="您确定要删除选中的报价单数据（包括销售参数）吗？" @confirm="deleteOrderFuc">
                <MyButton style="float: right;margin-right: 15px;padding:0 15px;" slot="reference">&#xe850;</MyButton>
            </el-popconfirm>
            <MyButton style="float: right;margin-right: 15px;padding:0 15px;">&#xe854;</MyButton>
        </div>
        <div class="com-codics-hbb-order-admin-goods-order-bar-content com-codics-hbb-order-admin-goods-order-bar-content2"
            style="margin-top: 10px;">
            <el-table :data="tableData" style="width: 100%;transition: .3s;" @selection-change="handleSelectionChange">
                <el-table-column type="expand" key="expand">
                    <template slot-scope="props">
                        <div class="com-codics-book-admin-project-list-item" style="width: 20%;"
                            v-for="(item, index) in props.row.list" :key="item.id">
                            <div class="com-codics-book-admin-project-list-item-card"
                                :style="{ 'border': item.checked ? '1px solid #9333ea' : '1px solid #E5E5E5', '--opacity': item.checked ? '1' : '0' }">
                                <el-image class="com-codics-book-admin-project-list-item-card-img"
                                    v-if="item.product.attach == ''"
                                    :src="item.product.himg.startsWith('http') ? item.product.himg : `https://cdn.bosscaigou.com/${item.product.himg}`"
                                    fit="cover"></el-image>
                                <div class="com-codics-book-admin-project-list-item-card-img" v-else>
                                    <div class="com-codics-book-admin-project-list-item-card-attach-item iconfont"
                                        @click="downloadFile(item2)" v-for="(item2, index2) in item.product.attach.split(',')"
                                        :key="index2">&#xEA84;{{ item2 }}
                                    </div>
                                </div>
                                <div class="com-codics-book-admin-project-list-item-card-bottom" :key="refreshKey">
                                    <span class="com-codics-book-admin-project-list-item-card-bottom-txt"
                                        style="padding-left: 10px;">{{ item.product.name
                                        }}</span>
                                    <!-- <el-input-number @change="(value) => addCartFuc(item, value - item.count2)"
                                        style="float: right;top: 50%;transform: translateY(-50%);right: 10px;"
                                        v-model="item.count" :min="0" :max="10" label="描述文字"
                                        size="mini"></el-input-number> -->
                                </div>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column type="selection" key="selection" width="50">
                </el-table-column>
                <el-table-column prop="id" key="id" v-if="[0, 19].includes(userInfo?.user?.member)" label="ID"
                    width="60">
                </el-table-column>
                <el-table-column prop="oid" key="oid" label="订单号" width="200">
                </el-table-column>
                <el-table-column prop="type" key="type" label="订单评级" width="150">
                    <template slot-scope="scope">
                        <el-rate v-model="scope.row.type" disabled text-color="#ff9900"
                            :colors="['#99A9BF', '#F7BA2A', '#FF9900']" score-template="{value}">
                        </el-rate>
                    </template>
                </el-table-column>
                <el-table-column prop="state" key="state" label="订单状态" width="90">
                    <template slot-scope="scope">
                        <el-tag
                            :type="['primary', 'info', 'warning', 'danger', 'primary', 'info', 'warning', 'success'][scope.row.state]"
                            disable-transitions size="mini">{{ ['询盘评级', '初始报价', '最终报价', '签署合同', '订单支付', '订单发货',
                                '订单待完结', '订单完成', '订单取消'][scope.row.state]
                            }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="cusInfo" label="客户信息" width="280">
                    <template slot-scope="scope">
                        <div style="margin-top: 5px;position: relative;float: left;margin-left: 5px;">{{
                            scope.row?.cusInfo?.name }}&nbsp;&nbsp;<span class="iconfont"
                                style="cursor: pointer;user-select: none;-webkit-user-drag: none;font-size: 14px;color: red;"
                                @click="copyPhone(scope.row?.account?.phone)">{{ scope.row?.cusInfo?.phone
                                }}&nbsp;&nbsp;&#xe749;
                                联系</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="label" label="销售信息" width="200">
                    <template slot-scope="scope">
                        <el-image style="height: 30px;width: 30px;position: relative;float: left;"
                            :src="scope.row?.account?.himg == null ? 'https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png' : 'https://cdn.bosscaigou.com/' + scope.row?.account?.himg"
                            fit="fill">
                        </el-image>
                        <div style="margin-top: 5px;position: relative;float: left;margin-left: 5px;">{{
                            scope.row?.account?.nickname }}&nbsp;&nbsp;<span class="iconfont"
                                style="cursor: pointer;user-select: none;-webkit-user-drag: none;font-size: 14px;color: red;"
                                @click="copyPhone(scope.row?.account?.phone)">&nbsp;&nbsp;&#xe749;
                                联系</span></div>

                    </template>
                </el-table-column>
                <el-table-column prop="ctime" label="创建时间" width="160">
                    <template slot-scope="scope">
                        {{ initTime(scope.row.ctime) }}
                    </template>
                </el-table-column>
                <el-table-column align="right" label="操作" min-width="150">
                    <template slot-scope="scope">
                        <el-popconfirm confirm-button-text='好的' cancel-button-text='不用了' icon="el-icon-info"
                            icon-color="red" title="您确定要取消当前订单吗？" @confirm="cancelOrderFuc([scope.row.id])">
                            <el-button v-if="scope.row.state < 7" type="danger" size="mini" style="float: right;"
                                slot="reference" plain>订单取消</el-button>
                        </el-popconfirm>
                        <el-button v-if="nowType == '报价单'" size="mini" style="float: right;margin-right: 7px;"
                            type="success" plain @click="baojiaData = scope.row; createXlsx();">下载报价单</el-button>
                        <el-popconfirm confirm-button-text='好的' cancel-button-text='不用了' icon="el-icon-info"
                            width="200px !important" icon-color="red" title="您确定要核销当前订单吗？"
                            @confirm="hexOrderFuc(scope.row)">
                            <el-button
                                v-show="nowType == '订单' && scope.row.state == 0 && [0, 19].includes(userInfo?.user?.member)"
                                type="warning" size="mini" style="float: right;margin-right: 7px;" slot="reference"
                                plain>核销订单</el-button>
                        </el-popconfirm>
                        <el-button type="success" size="mini" style="float: right;margin-right: 7px;"
                            @click="jumpDetail(scope.row.id)" plain>详情</el-button>
                        <el-button v-show="nowType == '报价单'" type="warning" size="mini"
                            style="float: right;margin-right: 7px;"
                            @click="orderForm.id = scope.row.id; orderDialog = true;" plain>生成订单</el-button>
                        <el-popconfirm confirm-button-text='确定' cancel-button-text='取消' icon="el-icon-info"
                            width="200px !important" icon-color="red" title="您确定要取消当前订单吗？"
                            @confirm="cancelOrderFuc(scope.row.id)">
                            <el-button v-show="nowType == '订单' && scope.row.state == 0" type="danger" size="mini"
                                style="float: right;margin-right: 7px;" slot="reference" plain>取消订单</el-button>
                        </el-popconfirm>
                        <el-button type="warning"
                            v-show="nowType == '订单' && (scope.row.state == 1 || scope.row.state == 2) && [0, 19].includes(userInfo?.user?.member)"
                            size="mini" style="float: right;margin-right: 7px;"
                            @click="nowWuLiu = scope.row; wuliuDrawer = true;" plain>去发货</el-button>
                        <el-button v-show="nowType == '订单' && scope.row.state == 2" size="mini"
                            style="float: right;margin-right: 7px;margin-left: 0;"
                            @click="nowWuLiu = scope.row; wuliuDrawer = true;" plain>查询物流</el-button>
                        <el-popconfirm confirm-button-text='完结' cancel-button-text='取消' icon="el-icon-info"
                            width="200px !important" icon-color="red" title="您确定要完结当前订单吗？"
                            @confirm="finishOrderCheck(scope.row)">
                            <el-button
                                v-show="nowType == '订单' && scope.row.state == 2 && [0, 19].includes(userInfo?.user?.member)"
                                type="danger" size="mini" style="float: right;margin-right: 7px;" slot="reference"
                                plain>完结订单</el-button>
                        </el-popconfirm>
                        <el-button v-if="scope.row.state == 0" size="mini" style="float: right;margin-right: 7px;"
                            type="warning" plain @click="nowId = scope.row.id; pfVisible = true;">订单评级</el-button>
                        <el-button v-if="scope.row.state == 1" size="mini" style="float: right;margin-right: 7px;"
                            type="warning" plain
                            @click="bjForm.id = scope.row.id; bjForm.oid = scope.row.id; bjForm.state = scope.row.state + 1; bjForm.type = scope.row.type; bjVisible = true; bjForm.title = '订单初始报价';">初始报价</el-button>
                        <el-button v-if="scope.row.state == 2" size="mini" style="float: right;margin-right: 7px;"
                            type="warning" plain
                            @click="bjForm.id = scope.row.id; bjForm.oid = scope.row.id; bjForm.state = scope.row.state + 1; bjForm.type = scope.row.type; zzbjVisible = true; bjForm.title = '订单最终报价';">最终报价</el-button>
                        <el-button v-if="scope.row.state == 3" size="mini" style="float: right;margin-right: 7px;"
                            type="warning" plain
                            @click="bjForm.id = scope.row.id; bjForm.oid = scope.row.id; bjForm.state = scope.row.state + 1; bjForm.type = scope.row.type; htVisible = true; bjForm.title = '上传订单合同';">上传合同</el-button>
                        <el-button v-if="scope.row.state == 4" size="mini" style="float: right;margin-right: 7px;"
                            type="warning" plain
                            @click="bjForm.id = scope.row.id; bjForm.oid = scope.row.id; bjForm.state = scope.row.state + 1; bjForm.type = scope.row.type; zfVisible = true; bjForm.title = '上传支付记录';">订单支付</el-button>
                        <el-button v-if="scope.row.state == 5" size="mini" style="float: right;margin-right: 7px;"
                            type="warning" plain
                            @click="bjForm.id = scope.row.id; bjForm.oid = scope.row.id; bjForm.state = scope.row.state + 1; bjForm.type = scope.row.type; fhVisible = true; bjForm.title = '上传订单物流';">订单发货</el-button>
                        <el-popconfirm confirm-button-text='好的' cancel-button-text='不用了' icon="el-icon-info"
                            @confirm="bjForm.id = scope.row.id; bjForm.oid = scope.row.id; bjForm.state = scope.row.state + 1; bjForm.type = scope.row.type; wjVisible = true; bjForm.title = '订单已完成'; bjForm.mess = '订单已完成，客户已清关收货！'; bjOrderFuc();"
                            icon-color="red" title="您确定要完结当前订单吗？">
                            <el-button v-if="scope.row.state == 6" size="mini" style="float: right;margin-right: 7px;"
                                slot="reference" type="warning" plain>完结订单</el-button>
                        </el-popconfirm>
                        <el-button size="mini" style="float: right;margin-right: 7px;" plain
                            @click="bjForm.id = scope.row.id; bjForm.oid = scope.row.id; bjForm.state = scope.row.state; bjForm.type = scope.row.type; messVisible = true;">添加消息</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination class="codics-aonaer-info-sys-news-pagination" background @size-change="handleSizeChange"
                @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 30, 40, 100]"
                :page-size="dataSize" layout="total, sizes, prev, pager, next, jumper, slot" :total="maxSize">
            </el-pagination>
        </div>
        <el-dialog title="生成订单" :visible.sync="orderDialog">
            <el-form :model="orderForm">
                <el-form-item label="收货模板" :label-width="formLabelWidth" required>
                    <el-select style="width: 330px;" v-model="orderForm.aid" placeholder="请选择收货地址">
                        <el-option v-for="item in myAreaOptions" :key="item.id"
                            :label="item.name + ' ' + item.phone + ' ' + item.country + ' ' + item.province + ' ' + item.city + ' ' + item.area"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="orderForm.aid === 0" label="收货地址" :label-width="formLabelWidth" required>
                    <el-cascader style="width: 330px;" :props="{ checkStrictly: true }" size="large" filterable
                        placeholder="请选择收货地址" :options="areaOptions" v-model="orderForm.origin" clearable>
                    </el-cascader>
                </el-form-item>
                <el-form-item v-show="orderForm.aid === 0" label="地址详情" :label-width="formLabelWidth" required>
                    <el-input v-model="orderForm.remark" style="width: 330px;" autocomplete="off"
                        placeholder="请输入地址详情，具体到楼号门牌号"></el-input>
                </el-form-item>
                <el-form-item v-show="orderForm.aid === 0" label="收件人" :label-width="formLabelWidth" required>
                    <el-input v-model="orderForm.name" style="width: 330px;" autocomplete="off"
                        placeholder="请输入收件人姓名"></el-input>
                </el-form-item>
                <el-form-item v-show="orderForm.aid === 0" label="联系方式" :label-width="formLabelWidth" required>
                    <el-input v-model="orderForm.phone" style="width: 330px;" autocomplete="off"
                        placeholder="请输入收件人联系方式"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="orderDialog = false;">取 消</el-button>
                <el-button type="primary" @click="changeOrderFuc">确 定 生 成</el-button>
            </div>
        </el-dialog>
        <MyDialog :visible.sync="pfVisible" title="询盘评级" :width="'950px'" height="fit-content" :out="false">
            <MyForm style="margin-top: 5px;padding: 0 5px;">
                <MyFormItem style="width:calc(50% - 7.5px);" label="询盘评级" required>
                    <el-select style="width:100%;" size="small" v-model="nowPf" filterable remote reserve-keyword
                        placeholder="请选择询盘评级">
                        <el-option v-for="(item, index) in [
                            {
                                value: 5,
                                label: '优质询盘'
                            },
                            {
                                value: 4,
                                label: '高级询盘'
                            },
                            {
                                value: 3,
                                label: '中级询盘'
                            },
                            {
                                value: 2,
                                label: '普通询盘'
                            },
                            {
                                value: 1,
                                label: '垃圾询盘'
                            }
                        ]" :key="index" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </MyFormItem>
            </MyForm>
            <div style="height: 32px;width:100%;position:relative;float:left;margin-top:60px;margin-bottom:20px;">
                <el-button size="small" style="float:right;" type="success" plain @click="rateOrderFuc">确认评级</el-button>
                <el-button size="small" style="float:right;margin-right: 10px;" plain
                    @click="pfVisible = false;">取消评级</el-button>
            </div>
        </MyDialog>
        <MyDialog :visible.sync="bjVisible" title="初始报价" :width="'950px'" height="fit-content" :out="false">
            <MyForm style="margin-top: 5px;padding: 0 5px;">
                <MyFormItem style="width:100%;" label="报价单附件">
                    <MyUpload v-model="bjForm.attachs" :limit="10" size="100px"></MyUpload>
                </MyFormItem>
                <MyFormItem style="width:100%;" label="报价备注" required>
                    <el-input type="textarea" autosize placeholder="请输入报价备注消息" v-model="bjForm.mess">
                    </el-input>
                </MyFormItem>
            </MyForm>
            <div style="height: 32px;width:100%;position:relative;float:left;margin-top:60px;margin-bottom:20px;">
                <el-button size="small" style="float:right;" type="success" plain @click="bjOrderFuc">初始报价</el-button>
                <el-button size="small" style="float:right;margin-right: 10px;" plain
                    @click="bjVisible = false;">取消报价</el-button>
            </div>
        </MyDialog>
        <MyDialog :visible.sync="zzbjVisible" title="最终报价" :width="'950px'" height="fit-content" :out="false">
            <MyForm style="margin-top: 5px;padding: 0 5px;">
                <MyFormItem style="width:100%;" label="报价单附件">
                    <MyUpload v-model="bjForm.attachs" :limit="10" size="100px"></MyUpload>
                </MyFormItem>
                <MyFormItem style="width:100%;" label="报价备注" required>
                    <el-input type="textarea" autosize placeholder="请输入报价备注消息" v-model="bjForm.mess">
                    </el-input>
                </MyFormItem>
            </MyForm>
            <div style="height: 32px;width:100%;position:relative;float:left;margin-top:60px;margin-bottom:20px;">
                <el-button size="small" style="float:right;" type="success" plain @click="bjOrderFuc">最终报价</el-button>
                <el-button size="small" style="float:right;margin-right: 10px;" plain
                    @click="zzbjVisible = false;">取消报价</el-button>
            </div>
        </MyDialog>
        <MyDialog :visible.sync="htVisible" title="上传合同" :width="'950px'" height="fit-content" :out="false">
            <MyForm style="margin-top: 5px;padding: 0 5px;">
                <MyFormItem style="width:100%;" label="合同附件">
                    <MyUpload v-model="bjForm.attachs" :limit="10" size="100px"></MyUpload>
                </MyFormItem>
                <MyFormItem style="width:100%;" label="合同备注" required>
                    <el-input type="textarea" autosize placeholder="请输入合同备注消息" v-model="bjForm.mess">
                    </el-input>
                </MyFormItem>
            </MyForm>
            <div style="height: 32px;width:100%;position:relative;float:left;margin-top:60px;margin-bottom:20px;">
                <el-button size="small" style="float:right;" type="success" plain @click="bjOrderFuc">上传合同</el-button>
                <el-button size="small" style="float:right;margin-right: 10px;" plain
                    @click="htVisible = false;">取消上传</el-button>
            </div>
        </MyDialog>
        <MyDialog :visible.sync="messVisible" title="添加消息" :width="'950px'" height="fit-content" :out="false">
            <MyForm style="margin-top: 5px;padding: 0 5px;">
                <MyFormItem style="width:100%;" label="消息标题">
                    <el-input v-model="bjForm.title" style="width: 100%;" size="small" placeholder="请输入消息标题"></el-input>
                </MyFormItem>
                <MyFormItem style="width:100%;" label="消息附件">
                    <MyUpload v-model="bjForm.attachs" :limit="10" size="100px"></MyUpload>
                </MyFormItem>
                <MyFormItem style="width:100%;" label="消息内容" required>
                    <el-input type="textarea" placeholder="请输入消息内容" :autosize="{ minRows: 4, maxRows: 6 }"
                        v-model="bjForm.mess">
                    </el-input>
                </MyFormItem>
            </MyForm>
            <div style="height: 32px;width:100%;position:relative;float:left;margin-top:60px;margin-bottom:20px;">
                <el-button size="small" style="float:right;" type="success" plain @click="bjOrderFuc">添加消息</el-button>
                <el-button size="small" style="float:right;margin-right: 10px;" plain
                    @click="messVisible = false;">取消添加</el-button>
            </div>
        </MyDialog>
        <MyDialog :visible.sync="zfVisible" title="订单支付" :width="'950px'" height="fit-content" :out="false">
            <MyForm style="margin-top: 5px;padding: 0 5px;">
                <MyFormItem style="width:100%;" label="支付记录附件">
                    <MyUpload v-model="bjForm.attachs" :limit="10" size="100px"></MyUpload>
                </MyFormItem>
                <MyFormItem style="width:100%;" label="支付备注" required>
                    <el-input type="textarea" autosize placeholder="请输入支付备注消息" v-model="bjForm.mess">
                    </el-input>
                </MyFormItem>
            </MyForm>
            <div style="height: 32px;width:100%;position:relative;float:left;margin-top:60px;margin-bottom:20px;">
                <el-button size="small" style="float:right;" type="success" plain @click="bjOrderFuc">上传支付记录</el-button>
                <el-button size="small" style="float:right;margin-right: 10px;" plain
                    @click="zfVisible = false;">取消上传</el-button>
            </div>
        </MyDialog>
        <MyDialog :visible.sync="fhVisible" title="订单发货" :width="'950px'" height="fit-content" :out="false">
            <MyForm style="margin-top: 5px;padding: 0 5px;">
                <MyFormItem style="width:100%;" label="物流记录附件">
                    <MyUpload v-model="bjForm.attachs" :limit="10" size="100px"></MyUpload>
                </MyFormItem>
                <MyFormItem style="width:100%;" label="物流备注" required>
                    <el-input type="textarea" autosize placeholder="请输入物流备注消息" v-model="bjForm.mess">
                    </el-input>
                </MyFormItem>
            </MyForm>
            <div style="height: 32px;width:100%;position:relative;float:left;margin-top:60px;margin-bottom:20px;">
                <el-button size="small" style="float:right;" type="success" plain @click="bjOrderFuc">上传物流记录</el-button>
                <el-button size="small" style="float:right;margin-right: 10px;" plain
                    @click="fhVisible = false;">取消上传</el-button>
            </div>
        </MyDialog>
    </div>
</template>

<style>
.com-codics-hbb-order-admin-goods-order-drawer-area-card {
    height: 100%;
    width: 100%;
    position: relative;
    float: left;
    background: #f5f5f5;
    border-radius: 10px;
    box-sizing: border-box;
}

.com-codics-hbb-order-admin-goods-order-drawer-area-icon {
    height: 100%;
    width: 50px;
    position: relative;
    float: left;
    text-align: center;
    font-size: 20px;
    color: #1bc31b;
    line-height: 100px;
}

.com-codics-hbb-order-admin-goods-order-drawer .el-drawer__body {
    box-sizing: border-box;
    padding: 0 20px;
}
</style>

<script>
import MyDialog from '@/components/MyDialog';
import MyForm from '@/components/MyForm';
import MyFormItem from '@/components/MyForm/MyFormItem';
import { mapState } from 'vuex';
import dayjs from 'dayjs';
import MyButton from '@/components/MyButton';
import MyUpload from '@/components/MyUpload';
import { addGoods, deleteGoods, updateGoods, listGoods, listGoodsBrand, rateOrder, bjOrder, listGoodsType, listTags, listGoodsOrder, listComInfo, listCusInfo, changeOrder, deleteOrder, hexOrder, cancelOrder, listArea, addTransport, infoTransport, finishOrder, payOrder, taxOrder, addOrder, deleteOrders, listOrders, queryCustomer, queryUsers } from '@/api';
import { jumpTo, randomString, readData, saveData, delData, copyTxt } from '@/utils/myutils';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import areaData from '../../../../public/data/data2.json';
export default {
    data() {
        return {
            zfVisible: false,
            fhVisible: false,
            wjVisible: false,
            messVisible: false,
            zzbjVisible: false,
            bjForm: {
                id: null,
                oid: null,
                title: '',
                mess: '',
                attach: '',
                attachs: [],
                state: 0,
                type: 0,
                idel: 0
            },
            htVisible: false,
            bjVisible: false,
            nowId: null,
            nowPf: 5,
            pfVisible: false,
            taxDrawer: false,
            taxList: [],
            payDrawer: false,
            payList: [],
            wuliuInfo: [],
            nowTrans: '',
            wuliuData: [
                {
                    value: 'shunfeng',
                    label: '顺丰快递'
                },
                {
                    value: 'zhongtong',
                    label: '中通快递'
                },
                {
                    value: 'yuantong',
                    label: '圆通快递'
                },
                {
                    value: 'shentong',
                    label: '申通快递'
                },
                {
                    value: 'jtexpress',
                    label: '极兔快递'
                },
                {
                    value: 'yunda',
                    label: '韵达快递'
                },
                {
                    value: 'jd',
                    label: '京东快递'
                },
                {
                    value: 'ems',
                    label: '邮政快递'
                },
                {
                    value: 'qitafangshi',
                    label: '其他方式'
                }
            ],
            wuliuData2: {
                'shunfeng': '顺丰快递',
                'zhongtong': '中通快递',
                'yuantong': '圆通快递',
                'shentong': '申通快递',
                'jtexpress': '极兔快递',
                'yunda': '韵达快递',
                'jd': '京东快递',
                'ems': '邮政快递',
                'qitafangshi': '其他方式'
            },
            transForm: {
                ids: [],
                oid: null,
                tid: null,
                type: '',
                remark: '',
            },
            transDialog: false,
            wuliuSee: false,
            nowWuLiu: null,
            wuliuDrawer: false,
            formLabelWidth: '110px',
            orderDialog: false,
            nowType: -1,
            comId: null,
            cusId: null,
            tableData: [],
            baojiaData: null,
            searchData: [],
            nowCid: null,
            nowState: -1,
            selectData: [],
            roleData: [],
            memsList: [],
            typeOptions: [
                {
                    value: -1,
                    label: '全部评级'
                },
                {
                    value: 5,
                    label: '优质询盘'
                },
                {
                    value: 4,
                    label: '高级询盘'
                },
                {
                    value: 3,
                    label: '中级询盘'
                },
                {
                    value: 2,
                    label: '普通询盘'
                },
                {
                    value: 1,
                    label: '垃圾询盘'
                }
            ],
            brandOptions: [],
            searchTxt: '',
            nowSearchTxt: '',
            currentPage: 1,
            searchPage: 1,
            dataSize: 10,
            searchSize: 10,
            maxSize: 0,
            searchMax: 0,
            goodsType: [],
            nowMode: -1,
            goodsBrand: [],
            comOptions: [],
            cusOptions: [],
            timeData: [],
            goodsTag: [],
            nowSid: null,
            areaOptions: areaData,
            myAreaOptions: [],
            orderForm: {
                aid: '',
                id: null,
                origin: null,
                remark: '',
                name: '',
                phone: '',
                country: '',
                province: '',
                city: '',
                area: ''
            },
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
            },
            customData: [],
            loading: false,
            userData: [],
            wuliuType: {
                'shunfeng': '顺丰快递',
                'zhongtong': '中通快递',
                'yuantong': '圆通快递',
                'shentong': '申通快递',
                'jtexpress': '极兔快递',
                'yunda': '韵达快递',
                'jd': '京东快递',
                'ems': '邮政快递',
                'qitafangshi': '其他方式'
            }
        }
    },
    components: {
        MyButton,
        MyUpload,
        MyDialog,
        MyForm,
        MyFormItem
    },
    computed: {
        ...mapState(['userInfo'])
    },
    mounted() {

        this.listOrdersFuc();

        this.listAreaFuc();

        this.listComInfoFuc();

        this.listCusInfoFuc();

    },
    methods: {
        downloadFile(item) {
            saveAs(`https://cdn.bosscaigou.com/${item}`, item.split('/').pop());
        },
        async queryUsersFuc(query) {
            if (query === '') {
                this.userData = [];
                return;
            }

            this.loading = true;

            const data = await queryUsers({
                key: query
            });

            this.loading = false;

            if (data.code == 200) {

                this.userData = data.data;

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }
        },
        async queryCustomFuc(query) {
            if (query === '') {
                this.customData = [];
                return;
            }

            this.loading = true;

            const data = await queryCustomer({
                key: query
            });

            this.loading = false;

            if (data.code == 200) {

                this.customData = data.data;

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }
        },
        async bjOrderFuc() {
            if (this.bjForm.id == null) {
                this.$message.error('请选择订单！');
                return;
            }
            if (this.bjForm.oid == null) {
                this.$message.error('请选择订单！');
                return;
            }
            if (this.bjForm.mess == '') {
                this.$message.error('请输入报价备注消息！');
                return;
            }
            this.bjForm.attach = this.bjForm.attachs.join(',');
            this.bjForm.attachs = [];
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const data = await bjOrder(this.bjForm);
            loading.close();
            if (data.code == 200) {
                this.$message({
                    message: '初始报价成功！',
                    type: 'success'
                });
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            } else {
                this.$message.error(data.message);
            }
        },
        async rateOrderFuc() {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const data = await rateOrder({
                id: this.nowId,
                rate: this.nowPf,
            });
            loading.close();
            if (data.code == 200) {
                this.$message({
                    message: '评级成功！',
                    type: 'success'
                });
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            } else {
                this.$message.error(data.message);
            }
        },
        async listOrdersFuc() {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const data = await listOrders({
                type: this.nowType,
                state: this.nowState,
                key: this.searchTxt,
                pge: this.currentPage,
                psz: this.dataSize,
                cid: this.nowCid,
                sid: this.nowSid,
                from: this.timeData == null ? null : (this.timeData[0] == null ? null : this.timeData[0]),
                to: this.timeData == null ? null : (this.timeData[1] == null ? null : this.timeData[1]),
                mode: this.nowMode
            });
            loading.close();
            if (data.code == 200) {
                this.tableData = data.data;
                this.maxSize = data.count;
            } else {
                this.$message.error(data.message);
            }
        },
        jumpDetail(id) {
            jumpTo(this, '订单详情', { id: id }, {});
        },
        copyPhone(phone) {
            console.log(phone)
            copyTxt(phone);
            this.$message({
                message: '复制成功！',
                type: 'success'
            });
        },
        async payOrderFuc() {

            if (this.payList.length == 0) {

                this.$message.error('请上传支付凭证！');

                return;

            }

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            const pay = this.payList.join(',');

            const data = await payOrder({ id: this.nowWuLiu.id, pay: pay });

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: '支付凭证上传成功！',
                    type: 'success'
                });

                setTimeout(() => {

                    window.location.reload();

                }, 300);

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        async taxOrderFuc() {

            if (this.taxList.length == 0) {

                this.$message.error('请上传发票截图！');

                return;

            }

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            const tax = this.taxList.join(',');

            const data = await taxOrder({ id: this.nowWuLiu.id, tax: tax });

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: '发票记录上传成功！',
                    type: 'success'
                });

                setTimeout(() => {

                    window.location.reload();

                }, 300);
            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }
        },
        async cancelOrderFuc(id) {

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await cancelOrder({ id: id });

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: '订单取消成功！',
                    type: 'success'
                });

                setTimeout(() => {

                    window.location.reload();

                }, 300);

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }
        },
        finishOrderCheck(row) {

            let _that = this;

            if (row.pay == null) {

                _that.$confirm('当前订单没有支付记录, 是否继续完结?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    if (row.invoice == null) {

                        _that.$confirm('当前订单没有发票上传记录, 是否继续完结?', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            _that.finishOrderFuc(row);
                        }).catch(() => {

                        });

                        return;

                    }
                    _that.finishOrderFuc(row);
                }).catch(() => {

                });

                return;

            }

            if (row.invoice == null) {

                this.$confirm('当前订单没有发票上传记录, 是否继续完结?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.finishOrderFuc(row);
                }).catch(() => {

                });

                return;

            }

            this.finishOrderFuc(row);

        },
        async finishOrderFuc(row) {

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await finishOrder({ id: row.id });

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: '订单成功完结！',
                    type: 'success'
                });

                setTimeout(() => {

                    window.location.reload();

                }, 300);

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }
        },
        async hexOrderFuc(row) {
            const loading = this.$loading({
                lock: true,
                text: '正在核销...',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const data = await hexOrder({ id: row.id });

            loading.close();

            if (data.code == 200) {

                this.$message({
                    type: 'success',
                    message: '订单核销成功！'
                });

                setTimeout(() => {

                    window.location.reload();

                })

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }
        },
        handleClose(done) {
            this.wuliuInfo = [];
            this.nowTrans = [];
            done();
        },
        handleWuliuChange(val) {

            if (val.type == 'qitafangshi') {

                this.wuliuInfo = [
                    {
                        ftime: this.initTime(val.ctime),
                        context: '订单已打包完成，选择的物流方式为其他方式发出，订单备注信息：' + val.remark,
                        type: '客户信息管理系统'
                    }
                ];

                return;

            }

            this.infoTransportFuc(val, this.nowWuLiu.area.phone);

        },
        async infoTransportFuc(val, phone) {

            const loading = this.$loading({
                lock: true,
                text: '正在查询...',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            const data = await infoTransport({ type: val.type, tid: val.tid, phone: phone });

            loading.close();

            if (data.code == 200) {

                let wData = JSON.parse(data.data.body);

                this.wuliuInfo = [
                    ...(wData.data == null ? [] : wData.data),
                    {
                        ftime: this.initTime(val.ctime),
                        context: wData.data == null ? '暂无更多物流信息，请耐心等待货物发出！' : '订单已打包完成，交付给物流公司发出！',
                        type: '客户信息管理系统'
                    }
                ];

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        async addTransportFuc() {

            if (this.orderForm.oid === null || this.orderForm.oid === '') {

                this.$message.error('请先选择订单！');

                return;

            }

            if (this.transForm.ids.length === 0) {

                this.$message.error('请选择绑定的商品！');

                return;

            }

            if (this.transForm.type === '') {

                this.$message.error('请选择物流方式！');

                return;

            }

            if (this.transForm.tid === '') {

                this.$message.error('请输入物流单号！');

                return;

            }

            const loading = this.$loading({
                lock: true,
                text: '正在提交...',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            const data = await addTransport(this.transForm);

            loading.close();

            if (data.code == 200) {

                this.$message({
                    type: 'success',
                    message: '添加物流信息成功！'
                });

                setTimeout(() => {

                    window.location.reload();

                }, 1000);

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        formatPhone(phone) {
            if (this.wuliuSee) return phone;
            if (typeof phone === 'number') phone = phone.toString(); // 处理数字类型输入
            const reg = /^1[3-9]\d{9}$/; // 验证手机号有效性
            if (!reg.test(phone)) return '无效手机号';
            return phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2'); // 正则分组替换
        },
        // 示例输出：138****5678,
        initComInfo(item) {
            return item == null ? {} : {
                com: item?.com,
                area: item?.area,
                name: item?.name,
                phone: item?.phone
            }
        },
        initPublicInfo(item) {
            return {
                com: item.com,
                area: item.area,
                phone: item.phone,
                tax: item.tax,
                bank: item.bank,
                acc: item.acc,
                bid: item.bid
            }
        },
        async listAreaFuc() {
            const data = await listArea();
            if (data.code == 200) {
                this.myAreaOptions = [
                    {
                        id: 0,
                        name: '新建地址',
                        phone: '',
                        country: '',
                        province: '',
                        city: '',
                        area: '',
                        remark: ''
                    },
                    ...data.data
                ];

                console.log(this.myAreaOptions)
            } else {
                if (data.code == 401) return;

                this.$message.error(data.message);
            }
        },
        initPrice2(row) {
            let price = 0;
            row.olist.forEach(item => {
                price += item.xp * item.count;
            });
            return price;
        },
        initPrice(row) {
            let price = 0;
            row.olist.forEach(item => {
                price += item.np * item.count;
            });
            return price;
        },
        async changeOrderFuc() {

            if (this.orderForm.aid === '') {

                this.$message.error('请选择收货地址！');

                return;

            }

            if (this.orderForm.aid == 0) {

                if (this.orderForm.origin == null || this.orderForm.origin.length == 0) {

                    this.$message.error('请先选择收货地址！');

                    return;

                }

                if (this.orderForm.name == '') {

                    this.$message.error('请输入收件人姓名！');

                    return;

                }

                if (this.orderForm.phone == '') {

                    this.$message.error('请输入收件人联系方式！');

                    return;

                }

                if (this.orderForm.remark == '') {

                    this.$message.error('请输入地址详情！');

                    return;

                }

                this.orderForm.country = this.orderForm.origin[0] || '中国';

                this.orderForm.province = this.orderForm.origin[1] || '';

                this.orderForm.city = this.orderForm.origin[2] || '';

                this.orderForm.area = this.orderForm.origin[3] || '';

            }

            if (this.orderForm.id == null) {

                this.$message.error('请选择要生成订单的报价单！');

                return;

            }

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            const data = await changeOrder({ ...this.orderForm });

            loading.close();

            if (data.code == 200) {

                this.$message({
                    type: 'success',
                    message: '生成订单成功！'
                });

                setTimeout(() => {

                    window.location.reload();

                }, 1000);

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        async downloadFileToFileObject(url) {
            try {
                // 发送请求
                const response = await fetch(url);

                // 检查响应状态
                if (!response.ok) {
                    throw new Error(`HTTP请求失败，状态码：${response.status}`);
                }

                // 将响应转换为 Blob
                const blob = await response.blob();

                // 从响应头或自定义逻辑获取文件名
                const contentDisposition = response.headers.get('content-disposition');
                const fileName = contentDisposition
                    ? decodeURIComponent(contentDisposition.split('filename=')[1].replace(/"/g, ''))
                    : 'downloaded_file'; // 默认文件名

                // 将 Blob 转换为 File 对象
                const file = new File([blob], fileName, { type: blob.type });

                return file;
            } catch (error) {
                console.error('下载或转换失败:', error);
                throw error;
            }
        },
        pxToEmu(px) {
            return Math.round(px * 9525);
        },
        // 图片转Base64工具函数
        async urlToBase64(url) {
            const response = await fetch(url);
            const blob = await response.blob();
            return new Promise((resolve) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result.split(',')[1]);
                reader.readAsDataURL(blob);
            });
        },
        createXlsx() {
            if (this.baojiaData == null) {
                this.$message.error('请先生成报价单！');
                return;
            }
            const _that = this;
            const reader = new FileReader()
            reader.onload = async (e) => {
                let templateBuffer = e.target.result
                let workbook = new ExcelJS.Workbook();
                workbook.calcProperties.fullCalcOnLoad = true;
                await workbook.xlsx.load(templateBuffer);
                const worksheet = workbook.getWorksheet('Sheet1');
                const insertRowIndex = 17;
                let cellData = [];
                let imageBase64 = await _that.urlToBase64('https://cdn.bosscaigou.com/' + this.baojiaData.comInfo?.icon);
                let imageId = workbook.addImage({
                    base64: imageBase64,
                    extension: 'png',
                });
                worksheet.addImage(imageId, {
                    tl: {
                        col: 1.1,
                        row: 3.05,
                        nativeColOff: 0,
                        nativeRowOff: 0
                    }, // 对应B2
                    br: {
                        col: 2.9,
                        row: 3.9,
                        nativeColOff: _that.pxToEmu(861) * 1.1,
                        nativeRowOff: _that.pxToEmu(359) * 1.1
                    },  // 占1列1行
                    // editAs: 'oneCell'        // 图片嵌入单元格
                });


                imageBase64 = await _that.urlToBase64('https://cdn.bosscaigou.com/' + this.baojiaData.comInfo?.seal);
                imageId = workbook.addImage({
                    base64: imageBase64,
                    extension: 'png',
                });
                worksheet.addImage(imageId, {
                    editAs: 'absolute',
                    tl: {
                        col: 1,
                        row: 3,
                        nativeColOff: 200 * 36000,
                        nativeRowOff: 200 * 36000
                    },
                    ext: { width: 240, height: 230 },
                });

                for (let i = 0; i < this.baojiaData.olist.length; i++) {

                    // const formula = worksheet.getRow(insertRowIndex + i).getCell(8).formula;

                    cellData.push(insertRowIndex + i);

                    worksheet.insertRow(insertRowIndex + i, [
                        '',
                        i + 1,
                        this.baojiaData.olist[i]?.goods?.title || '',
                        this.baojiaData.olist[i]?.title || '',
                        this.baojiaData.olist[i]?.unit || '',
                        parseInt(this.baojiaData.olist[i]?.count, 10),
                        parseFloat(this.baojiaData.olist[i]?.xp).toFixed(2),
                        this.baojiaData.olist[i]?.xp * this.baojiaData.olist[i]?.count,
                        ''
                    ]);
                    let imageBase64 = await _that.urlToBase64('https://cdn.bosscaigou.com/' + this.baojiaData.olist[i]?.img);
                    let imageId = workbook.addImage({
                        base64: imageBase64,
                        extension: 'png',
                    });
                    worksheet.addImage(imageId, {
                        tl: { col: 8, row: insertRowIndex + i - 1 }, // 对应B2
                        br: { col: 9, row: insertRowIndex + i },  // 占1列1行
                        editAs: 'oneCell'        // 图片嵌入单元格
                    });

                }

                worksheet.eachRow((row, rowNumber) => {
                    row.eachCell((cell) => {
                        console.log(cell);
                        if (cell.value && !cell.formula) {
                            cell.value = cell.value.toString().replace('#报价单位#', this.baojiaData.comInfo.com)
                                .replace('#报价单位地址#', this.baojiaData.comInfo.area)
                                .replace('#报价联系人#', this.baojiaData.comInfo.name)
                                .replace('#报价联系方式#', this.baojiaData.comInfo.phone)
                                .replace('#当前时间#', dayjs().format('YYYY年MM月DD日 HH:mm:ss'))
                                .replace('#询价单位#', this.baojiaData.cusInfo == null ? '' : this.baojiaData.cusInfo.com)
                                .replace('#询价单位地址#', this.baojiaData.cusInfo == null ? '' : this.baojiaData.cusInfo.area)
                                .replace('#询价联系人#', this.baojiaData.cusInfo == null ? '' : this.baojiaData.cusInfo.name)
                                .replace('#询价联系方式#', this.baojiaData.cusInfo == null ? '' : this.baojiaData.cusInfo.phone)
                                .replace('#发票类型#', ['普通发票', '增值税专用发票', '不开发票'][this.baojiaData.taxtype])
                                .replace('#税率#', this.baojiaData.tax)
                                .replace('#对公公司名称#', this.baojiaData.publicInfo.com)
                                .replace('#对公公司地址#', this.baojiaData.publicInfo.area)
                                .replace('#对公联系方式#', this.baojiaData.publicInfo.phone)
                                .replace('#对公税号#', this.baojiaData.publicInfo.tax)
                                .replace('#对公开户行#', this.baojiaData.publicInfo.bank)
                                .replace('#对公账号#', this.baojiaData.publicInfo.acc)
                                .replace('#对公行号#', this.baojiaData.publicInfo.bid);
                        }
                        if (cell.formula) {
                            cell.value = { formula: cell.formula }; // 重新绑定公式
                        }
                    });
                });



                // worksheet.insertRow(insertRowIndex, newData);

                // 复制前一行样式
                const referenceRow = worksheet.getRow(insertRowIndex + this.baojiaData.olist.length);

                cellData.forEach((cell, index) => {
                    worksheet.getRow(cell).eachCell((cell, colNumber) => {
                        const refCell = referenceRow.getCell(colNumber);
                        cell.style = JSON.parse(JSON.stringify(refCell.style));//refCell.style;//
                        cell.alignment = { ...refCell.alignment };
                        cell.fill = refCell.fill;
                    });
                });

                // worksheet.getRow(insertRowIndex).eachCell((cell, colNumber) => {
                //     const refCell = referenceRow.getCell(colNumber);
                //     cell.style = refCell.style;//JSON.parse(JSON.stringify(refCell.style));//
                //     cell.alignment = { ...refCell.alignment };
                //     cell.fill = refCell.fill;
                //     // cell.value = refCell.value; // 包括公式
                // });
                // 调整合并区域
                Object.entries(worksheet._merges).forEach(([key, value]) => {
                    let merge = worksheet._merges[key];
                    if (merge.bottom >= insertRowIndex) {
                        merge.bottom += this.baojiaData.olist.length; // 调整底部
                        merge.top += this.baojiaData.olist.length; // 调整顶部
                    }
                });

                worksheet.spliceRows(insertRowIndex + this.baojiaData.olist.length, 1);


                // worksheet.getCell(`H${insertRowIndex + this.baojiaData.olist.length}`).numFmt = '0.00';
                // worksheet.getCell(`F${insertRowIndex + this.baojiaData.olist.length}`).numFmt = '0';
                // 解除B5:D7合并
                // worksheet.unMergeCells('B5:D7');

                // worksheet.getRow(insertRowIndex + this.baojiaData.olist.length).getCell(6).value = 111;
                worksheet.getRow(insertRowIndex + this.baojiaData.olist.length).getCell(8).value = {
                    formula: `SUM(H${insertRowIndex}:H${insertRowIndex + this.baojiaData.olist.length - 1})`
                };
                worksheet.getRow(insertRowIndex + this.baojiaData.olist.length).getCell(6).value = {
                    formula: `SUM(F${insertRowIndex}:F${insertRowIndex + this.baojiaData.olist.length - 1})`
                };
                // 插入图片后重新合并
                worksheet.mergeCells(`B${insertRowIndex + this.baojiaData.olist.length}:E${insertRowIndex + this.baojiaData.olist.length}`);
                // 设置公式（假设F1=第1行第6列，F2=第2行第6列）

                // worksheet.getColumn(6).numFmt = undefined;
                // worksheet.getColumn(7).numFmt = undefined;

                this.baojiaData.olist.forEach((item, index) => {

                    worksheet.getCell(`F${insertRowIndex + index}`).value = parseInt(item.count, 10);

                    worksheet.getCell(`G${insertRowIndex + index}`).value = item.xp;

                    worksheet.getRow(insertRowIndex + index).getCell(6).numFmt = '0';

                    worksheet.getRow(insertRowIndex + index).getCell(7).numFmt = '0.00';

                    worksheet.getRow(insertRowIndex + index).getCell(8).numFmt = '0.00';

                    worksheet.getRow(insertRowIndex + index).getCell(8).value = {
                        formula: `F${insertRowIndex + index}*G${insertRowIndex + index}`
                    };

                });



                // worksheet.mergeCells(`B${insertRowIndex + this.baojiaData.olist.length + 1}:I${insertRowIndex + this.baojiaData.olist.length + 1}`);
                // worksheet.mergeCells('B5:D7');
                // 关键设置：强制Excel打开时重新计算所有公式
                // worksheet.getRow(insertRowIndex + this.baojiaData.olist.length).getCell(6).numFmt = '0';
                worksheet.getRow(insertRowIndex + this.baojiaData.olist.length).getCell(8).numFmt = '0.00';

                workbook.calcProperties.fullCalcOnLoad = true;
                const buffer = await workbook.xlsx.writeBuffer(); // ✅ 浏览器端专用 API
                const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                saveAs(blob, `${this.baojiaData?.comInfo?.name}报价单_` + `${this.baojiaData?.cusInfo == null ? '' : this.baojiaData?.cusInfo?.com}_` + `${this.baojiaData?.account?.id}_` + new Date().getTime() + '.xlsx');

            }
            // 调用函数并处理结果
            this.downloadFileToFileObject('https://cdn.bosscaigou.com/huayuan/xlsx/model.xlsx')
                .then(file => {
                    // console.log('File对象:', file);
                    reader.readAsArrayBuffer(file);

                })
                .catch(error => {
                    // 错误处理
                });
        },
        async listComInfoFuc() {
            const data = await listComInfo();
            if (data.code == 200) {
                this.comOptions = data.data;
            } else {
                if (data.code == 401) return;

                this.$message.error(data.message);
            }
        },
        async listCusInfoFuc() {
            const data = await listCusInfo();
            if (data.code == 200) {
                this.cusOptions = data.data;
            } else {
                if (data.code == 401) return;

                this.$message.error(data.message);
            }
        },
        async listGoodsOrderFuc() {

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            const data = await listGoodsOrder({
                type: this.nowType == '报价单' ? 0 : 1,
                key: this.nowSearchTxt,
                pge: this.searchTxt == '' ? this.currentPage : this.searchPage,
                psz: this.searchTxt == '' ? this.dataSize : this.searchSize,
                com: this.comId == '' ? null : this.comId,
                cus: this.cusId == '' ? null : this.cusId,
                from: this.timeData == null ? null : this.timeData[0],
                to: this.timeData == null ? null : this.timeData[1]
            });

            loading.close();
            if (data.code == 200) {

                if (this.searchTxt == '') {

                    this.tableData = data.data;

                    this.maxSize = data.count;

                } else {

                    this.searchData = data.data;

                    this.searchMax = data.count;

                }

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        async listTagsFuc() {
            const data = await listTags();
            if (data.code == 200) {
                this.tagsOptions = data.data;
            } else {
                if (data.code == 401) return;

                this.$message.error(data.message);
            }
        },
        async listGoodsBrandFuc() {
            const data = await listGoodsBrand();
            if (data.code == 200) {
                this.brandOptions = data.data;
            } else {
                if (data.code == 401) return;

                this.$message.error(data.message);
            }
        },
        async listGoodsTypeFuc() {
            const data = await listGoodsType();
            if (data.code == 200) {
                this.typeOptions = data.data;
            } else {
                if (data.code == 401) return;

                this.$message.error(data.message);
            }
        },
        jumpToPage(n, p, q) {
            jumpTo(this, n, p, q);
        },
        roleChange() {

            if (this.nowSearchTxt == '') {

                this.currentPage = 1;

                this.dataSize = 10;

                this.tableData = [];

                this.listGoodsOrderFuc();

            } else {

                this.searchPage = 1;

                this.searchSize = 10;

                this.searchData = [];

                this.listGoodsOrderFuc();

            }

        },
        async listRoleFuc() {

            const data = await listRole();

            if (data.code == 200) {

                this.roleData = data.data;

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        addGoodsCommand(a) {
            switch (a) {
                case '直接创建':
                    this.registerDialog2 = true;
                    break;
                case '邀请注册':
                    this.registerDialog = true;
                    break;
            }
        },
        searchGoodss() {

            if (this.searchTxt == '') {

                this.$message.error('请先输入要搜索的内容！');

                return;

            }

            this.searchPage = 1;

            this.searchMax = 0;

            this.searchData = [];

            this.nowSearchTxt = this.searchTxt;

            this.listGoodsOrderFuc();

        },
        async listGoodssFuc() {

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            const data = await listGoods({
                key: this.nowSearchTxt,
                pge: this.searchTxt == '' ? this.currentPage : this.searchPage,
                psz: this.searchTxt == '' ? this.dataSize : this.searchSize,
                type: this.goodsType.length == 0 ? 0 : this.goodsType[this.goodsType.length - 1],
                brand: this.goodsBrand.length == 0 ? 0 : this.goodsBrand[this.goodsBrand.length - 1],
                tags: this.goodsTag
            });

            loading.close();

            if (data.code == 200) {

                if (this.searchTxt == '') {

                    this.tableData = data.data;

                    this.maxSize = data.count;

                } else {

                    this.searchData = data.data;

                    this.searchMax = data.count;

                }

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        async deleteOrderFuc(t) {

            if (t == null) {

                if (this.selectData.length == 0) {

                    this.$message({
                        showClose: true,
                        message: '请先选中要删除的数据！',
                        type: 'warning'
                    });

                    return true;

                }

                var t = [];

                this.selectData.forEach(item => {

                    t[t.length] = item.id;

                });

            }

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await deleteOrder({ ids: t });

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: data.count + '条数据删除成功！',
                    type: 'success'
                });

                setTimeout(() => {

                    window.location.reload();

                }, 300);

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        handleSizeChange(val) {
            this.dataSize = val;
            this.listOrdersFuc();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.listOrdersFuc();
        },
        handleSelectionChange(val) {
            this.selectData = val;
        },
        handleTypeChange(a) {
            this.listGoodsOrderFuc();
        },
        searchChange(a) {
            if (a == '') {
                this.searchPage = 1;
                this.searchData = [];
                this.searchMax = 0;
                this.searchSize = 10;
                this.nowSearchTxt = '';
            }
        },
        stateFilter(v, r, c) {

            return r.state === v;

        },
        tsFilter(v, r, c) {

            return r.ts === v;

        },
        initTime(str) {
            return dayjs(str).format('YYYY-MM-DD HH:mm:ss');
        },
    }
}
</script>

<style>
.com-codics-hbb-order-admin-goods-order-body {
    /* height: fit-content;
    min-height: 100%;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 10px; */
    height: calc(100vh - 50px);
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 10px;
    overflow-y: scroll;
    width: calc(100% + 20px);
    overflow-y: scroll;
    padding-right: 20px;
}

:root {
    --el-input-bg-color: #FFF;
    --el-input-l-color: #DCDFE6;
    --el-input-l-hover-color: #C0C4CC;
    --el-input-l-focus-color: #000;
    --el-table-bg-color: #FFF;
    --el-table-l-color: #EBEEF5;
    --el-table-bg-hover-color: #F5F7FA;
    --el-table-body-font-color: #606266;
    --el-table-page-bg-color: #FFF;
    --el-table-page-bg-active-color: #333;
    --el-table-page-font-color: #606266;
    --el-table-page-font-active-color: #FFF;
}

:root[data-theme="dark"] {
    --el-input-bg-color: #333;
    --el-input-l-color: #444;
    --el-input-l-hover-color: #555;
    --el-input-l-focus-color: #888;
    --el-table-bg-color: #333;
    --el-table-l-color: #444;
    --el-table-bg-hover-color: #555;
    --el-table-body-font-color: #999;
    --el-table-page-bg-color: #292B2C;
    --el-table-page-bg-active-color: #FFF;
    --el-table-page-font-color: #AAA;
    --el-table-page-font-active-color: #333;
}

.el-input__inner {
    background-color: var(--el-input-bg-color) !important;
    border-color: var(--el-input-l-color) !important;
}

.el-input__inner:hover {
    border-color: var(--el-input-l-hover-color) !important;
}

.el-input__inner:focus {
    border-color: var(--el-input-l-focus-color) !important;
}

.el-table th.el-table__cell {
    background-color: var(--el-table-bg-color) !important;
}

.el-table tr {
    background-color: var(--el-table-bg-color) !important;
}

.el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
    border-bottom: 1px solid var(--el-table-l-color) !important;
}

.el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell {
    background-color: var(--el-table-bg-hover-color) !important;
}

.el-table--border::after,
.el-table--group::after,
.el-table::before {
    background-color: var(--el-table-l-color) !important;
}

.el-table {
    color: var(--el-table-body-font-color) !important;
}

.el-table,
.el-table__expanded-cell {
    background: var(--el-table-bg-color) !important;
}

.com-codics-hbb-order-admin-goods-order-bar-content {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    background: var(--sbar-bg-color);
    border-radius: 6px;
    border: 1px solid var(--sbar-l-3-color);
    padding: 15px;
    transition: .3s;
}

.com-codics-hbb-order-admin-goods-order-bar-content2 {
    box-sizing: border-box;
    padding: 20px;
}

.com-codics-hbb-order-admin-goods-order-bar-pick {
    position: relative;
    float: left;
    box-sizing: border-box;
    margin-right: 15px;
}

.com-codics-hbb-order-admin-goods-order-bar-input {
    width: 220px !important;
    position: relative;
    float: left;
    box-sizing: border-box;
}

.codics-aonaer-info-sys-news-pagination {
    height: fit-content;
    position: relative;
    float: left;
    /* left: 50%; */
    margin-top: 20px;
    /* transform: translateX(-50%); */
}

.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
    background-color: var(--el-table-page-bg-color) !important;
    color: var(--el-table-page-font-color) !important;
}

.el-pagination.is-background .el-pager .active {
    background-color: var(--el-table-page-bg-active-color) !important;
    color: var(--el-table-page-font-active-color) !important;
}

.com-codics-hbb-order-admin-goods-order-item-box {
    height: 155px;
    width: 25%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 10px;
    transition: .3s;
    display: flex;
}

.com-codics-hbb-order-admin-goods-order-item-card {
    height: 100%;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    border-radius: 8px;
    transition: .3s;
    background: #F9F9F9;
    border: 1px solid #DDD;
    cursor: pointer;
}

.com-codics-hbb-order-admin-goods-order-item-card-line {
    height: 100px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 10px;
    transition: .3s;
}

.com-codics-hbb-order-admin-goods-order-item-card-line::before {
    content: '';
    height: 1px;
    width: calc(100% - 20px);
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    bottom: 0;
    background: #EEE;
}

.com-codics-hbb-order-admin-goods-order-item-card-line-img {
    height: 80px;
    width: 80px;
    position: relative;
    float: left;
    box-sizing: border-box;
    overflow: hidden;
    border-radius: 8px;
}

.com-codics-hbb-order-admin-goods-order-item-card-line-text {
    height: 30px;
    width: calc(100% - 80px);
    position: relative;
    float: left;
    box-sizing: border-box;
    padding-left: 10px;
    transition: .3s;
    line-height: 30px;
    font-size: 11px;
    font-weight: bolder;
    color: #333;
}

.com-codics-hbb-order-admin-goods-order-item-card-line-text .el-tag {
    font-size: 9px;
}

.com-codics-hbb-order-admin-goods-order-item-card-line-text2 {
    height: 25px;
    line-height: 25px;
    color: #999;
}

.com-codics-hbb-order-admin-goods-order-item-card-line2 {
    height: 35px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    line-height: 35px;
    font-size: 11px;
    font-weight: bolder;
    color: #666;
    padding-left: 10px;
    user-select: none;
}

.com-codics-hbb-order-admin-goods-order-item-card-more-btn {
    height: 35px;
    width: 35px;
    position: relative;
    float: right;
    box-sizing: border-box;
    line-height: 35px;
    text-align: center;
    font-size: 11px;
    color: #333;
    cursor: pointer;
    user-select: none;
}

.com-codics-hbb-order-admin-goods-order-item-card2 {
    border: 1px dashed #666;
    border-radius: 8px;
    transition: .3s;
    background: transparent;
    cursor: pointer;
}

.com-codics-hbb-order-admin-goods-order-item-card2::before,
.com-codics-hbb-order-admin-goods-order-item-card2::after {
    content: '';
    height: 1px;
    width: 25px;
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    transition: .3s;
    background: #666;
}

.com-codics-hbb-order-admin-goods-order-item-card2::after {
    transform: rotate(90deg);
}

.com-codics-hbb-order-admin-goods-order-drawer-empty {
    height: 150px;
    width: 150px;
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    box-sizing: border-box;
    user-select: none;
    -webkit-user-drag: none;
    cursor: pointer;
}

.com-codics-hbb-order-admin-goods-order-drawer-empty-txt {
    height: 50px;
    width: 100%;
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    top: 200px;
    bottom: 0;
    box-sizing: border-box;
    text-align: center;
    box-sizing: border-box;
    line-height: 50px;
    font-size: 12px;
    font-weight: bolder;
    color: #333;
    cursor: pointer;
}

.com-codics-hbb-order-admin-goods-order-drawer-area-box {
    height: 120px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 10px 0;
    transition: .3s;
}

.com-codics-hbb-order-admin-goods-order-drawer-area-info {
    height: 100%;
    width: calc(100% - 100px);
    position: relative;
    float: left;
    line-height: 35px;
    font-size: 12px;
    color: #333;
    box-sizing: border-box;
    padding: 15px 0;
}
</style>